import React from "react";

const TourismHero: React.FC = () => {
  return (
    <div>
      <div className="flex flex-col justify-center items-center px-3 w-full">
        <div className="text-center text-white text-2xl md:text-3xl pt-5 w-full max-w-4xl lg:text-4xl font-light xl:text-[3.4rem] xl:space-y-7">
          <h3 className="">Tour Guide App by Dream Weavers</h3>
        </div>
        <p className="pt-4 xl:pt-10 text-sm text-center max-w-xl xl:text-[25.5px] font-light text-[#FF7E00]">
          Revolutionizing Tourism Through Technology
        </p>
        <p className="pt-4 xl:pt-8 text-sm xl:text-base text-center max-w-4xl font-light text-white">
          At Dream Weavers, we believe that every landmark has a story to tell,
          and our cutting-edge Tour Guide App is designed to bring these stories
          to life. Using advanced technologies like GPS and Bluetooth, we offer
          an immersive audio experience for tourists worldwide, ensuring they
          never miss a detail—be it a historical site, a cultural hotspot, or a
          spiritual pilgrimage.
        </p>
      </div>
      <div className="flex justify-center items-center pt-[5rem] xl:pt-[5.5rem] -mb-[8rem] md:pt-10 md:-mb-[13rem] xl:-mb-[20rem]">
        <div className="max-w-lg md:max-w-2xl h-[12rem] sm:h-[19rem] rounded-xl lg:rounded-3xl md:w-[34rem] lg:h-[28rem] sm:w-[29rem] lg:max-w-4xl xl:h-[32rem] lg:w-[90rem]">
          <img src="/tourism/hero.png" alt="" className="w-full h-full" />
        </div>
      </div>
    </div>
  );
};

export default TourismHero;
